import React, { Component, Fragment } from 'react'
import { Switch, Route, Redirect } from 'react-router'
import TorontoCityCouncil from '../../containers/TorontoCityCouncil'
import TorontoAttendance from '../../containers/TorontoAttendance'
import TorontoCouncillor from '../../containers/TorontoCouncillor'
import AppBar from '../AppBar'

class App extends Component<void> {
  render () {
    return (
      <Fragment>
        <Switch>
          <Route path='/toronto/councillors/:councillorId' component={null} />
          <Route path='/toronto' component={AppBar} />
        </Switch>
        <Switch>
          <Route path='/toronto/councillors/:councillorId' component={TorontoCouncillor} />
          <Route path='/toronto/councillors' component={TorontoAttendance} />
          <Route path='/toronto' component={TorontoCityCouncil} />
          <Redirect from='/' to='/toronto' />
        </Switch>
      </Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/App.js